class UpsellProduct{
  constructor(products){
    this.upsell_products = products;

    this.upsell_id = "";
    this.note_often = "";

    this.no_of_steps = 3;

    // this.subscriptions = {
    //   "48134954156369": {
    //     "5-7 days per week": "689026793809",
    //     "2-4 days per week": "689026826577",
    //     "5-7 days per week": "689026793809",
    //   }
    // };

    this.subscriptions = {};

    this.cat_items = [];

    this.__init();
  }

  __init(){
  let self = this;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(response) {
        self.cat_items = response.items;
      },
      error: function(error) {
        console.error('Error adding product(s) to cart', error);
      }
    });

    this.go_to_next_step();

    this.bac_to_step();

    this.get_selling_plans();

    this.select_products();
  }

  select_products () {
    $(document).on('change', '.upsell_products input', function () {
      if ($(this).prop('checked') == true) {
        let index = $(this).parents('.upsell_products').index();
        $(`.product-form__input--ongoing-refills input[data-index="${index}"] + label`)[0].click();
      }
    });
    $(`.product-form__input--ongoing-refills input[data-index="1"] + label`)[0].click();
  }

  get_selling_plans(){

    this.upsell_products.map(product => {
      
      let variant_id = product.variants[0].id;
      this.subscriptions[variant_id] = {};
      
      if(product.selling_plan_groups){
        let selling_plan_groups = product.selling_plan_groups;
        
        selling_plan_groups.map(selling_plan => {
          let selling_id = selling_plan['selling_plans'][0].id;
          let name = $.trim(selling_plan.name);
          
          if(name == "2 month subscription"){
            this.subscriptions[variant_id]['2_month'] = selling_id;
          }else if(name == "3 month subscription"){
            this.subscriptions[variant_id]['3_month'] = selling_id;
          }else{
            this.subscriptions[variant_id]['5_month'] = selling_id;
          }
          // if(name == "2 month subscription with 100% discount"){
          //   this.subscriptions[variant_id]['2_month'] = selling_id;
          // }else if(name == "3 month subscription with 100% discount"){
          //   this.subscriptions[variant_id]['3_month'] = selling_id;
          // }else{
          //   this.subscriptions[variant_id]['5_month'] = selling_id;
          // }
          
        })
        
      }
      
    })
    // this.upsell_products.map(product => {
      
    //   let variant_id = product.variants[0].id;
    //   this.subscriptions[variant_id] = {};
      
    //   if(product.selling_plan_groups){
    //     let selling_plan_groups = product.selling_plan_groups[0]['selling_plans'];
        
    //     selling_plan_groups.map(selling_plan => {
    //       let selling_id = selling_plan.id;
    //       let name = $.trim(selling_plan.name);
          
    //       if(name == "Trial Subscriptions-2 month subscription"){
    //         this.subscriptions[variant_id]['2_month'] = selling_id;
    //       }else if(name == "Trial Subscriptions-3 month subscription"){
    //         this.subscriptions[variant_id]['3_month'] = selling_id;
    //       }else{
    //         this.subscriptions[variant_id]['5_month'] = selling_id;
    //       }
          
    //     })
        
    //   }
      
    // })

    // console.log(this.upsell_products, this.subscriptions);
    
  }

  go_to_next_step(){
    let self = this;
    $(document).on("click", ".steps_btn", function(){

      if($(this).attr("step") == "1"){
        $(".step_1_elm").addClass("d-none");
        self.ongoing_Refills();
      }else if($(this).attr("step") == "2"){

        let is_selected = false;
        $('.upsell_products input[name="upsell_product_id"]').each((i, elm) => {
          if($(elm).is(":checked")){
            self.upsell_id = parseInt($(elm).val());
            is_selected = true;
          }
        })
        if(!is_selected){
          alert("Please select one product Please!");
          return;
        }

        
        $(".step_2_elm").addClass("d-none");
        self.often_step();
      } else if($(this).attr("step") == "3"){

        let is_selected = false;
        $('.often_products input[name="often"]').each((i, elm) => {
          if($(elm).is(":checked")){
            self.note_often = $(elm).val();
            is_selected = true;
          }
        })

        if(!is_selected){
          alert("Please select one product Please!");
          return;
        }

        var is_selected2 = self.check_upsellProduct_Selected();
        if(!is_selected2){
          $(".progress-container .step").eq(1).click();
          alert("Please select one product Please!");
          return;
        }

        self.addToCart();
        
      }
      
      self.step_activate($(this).attr("step"));
      
    })
  }

  step_activate(step_number, top_bar = false) {
    $(".progress-container .step").removeClass("active");

    step_number = parseInt(step_number);
    if(top_bar){
      // step_number--;
    }else{
      step_number++;
    }

    for (let i = 0; i < step_number; i++) {
      $(".progress-container .step").eq(i).addClass("active");
    }
    // console.log($(".progress-container .step").eq(step_number), step_number);
    // $(".progress-container .step").eq(step_number).addClass("active");

  }

  bac_to_step(){

    let self = this;
    $(document).on("click", ".progress-container .step", function(main){

      $(".progress-container .step").each(function(i, elm){
        $(elm).removeClass("active");
      })

      $(this).addClass("active");

      $(".progress-container .step").each(function(index, elm){
        if($(this).hasClass("active")){

          for (let i = 1; i <= self.no_of_steps; i++) {
            $(`.step_${i}_elm`).addClass("d-none");
          }

          let no = index + 1;

          if(no == 2){
            self.ongoing_Refills();
          }
          $(`.step_${no}_elm`).removeClass("d-none")
        }
      })
      self.step_activate($(this).attr("step"), true);
      
    });
    
  }

  ongoing_Refills(){

    let html = this.upsell_products.map((product, i) => {
      console.log(i)
      let price = (product.price / 100).toFixed(0);
      let compare_at_price = (product.compare_at_price / 100).toFixed(0);
      let product_id = product.variants[0].id;
      let checked = "";
      if(i == 1){
        checked = "checked";
      }
      
      if(price == compare_at_price){
        return `<input type="radio" class="visibility-hidden" name="upsell_product_id" ${checked} id="${product_id}" value="${product_id}" />
          <label class="cursor-pointer d-block" for="${product_id}">
          <label class="cursor-pointer d-block">
            <div class="card border-0">
            
              <div class="refills-imag d-flex justify-content-center">
                  <img src="${product.media[0].src}&width=400" alt="" class="img-fluid">
              </div>

              <div class="refills-text-section d-flex justify-content-between custom-text">
                  <div class="bladdes-text margin_l ">
                      <h4>${product.title}</h4>
                      <span class="margin_b">${product.description}</span>
                  </div>
                  <div class="price_section custom-price">
                      <span class="margin_b">£${price}</span>
                  </div>
              </div>
              
            </div>
          </label>
        </div>`
      }else{
        return `<div class="col-md-4 upsell_products">
            <input type="radio" class="visibility-hidden" name="upsell_product_id" ${checked} id="${product_id}" value="${product_id}" />
          <label class="cursor-pointer d-block" for="${product_id}">
            <div class="card border-0">
            
              <div class="refills-imag d-flex justify-content-center">
                  <img src="${product.media[0].src}&width=400" alt="" class="img-fluid">
              </div>

              <div class="refills-text-section d-flex justify-content-between custom-text">
                  <div class="bladdes-text margin_l ">
                      <h4>${product.title}</h4>
                      <span class="margin_b">${product.description}</span>
                  </div>
                  <div class="price_section custom-price">
                      <h4 class="line-through">£${compare_at_price}</h4>
                      <span class="margin_b">£${price}</span>
                  </div>
              </div>
              
            </div>
          </label>
          </div>`
      }
      
    })

    $(".step_2_elm").removeClass("d-none");
    $(".step_2_elm .row").html(html.join(''))
    // step_2_elm
  }

  often_step(){
    $(".step_3_elm").removeClass("d-none");
  }

  check_upsellProduct_Selected(){
      let is_selected = false;
      $('.upsell_products input[name="upsell_product_id"]').each((i, elm) => {
        if($(elm).is(":checked")){
          self.upsell_id = parseInt($(elm).val());
          is_selected = true;
        }
      })
    
      return is_selected;
      
  }

  addToCart() {
    let self = this;
    let items = [];
    // alert(555)
    
    this.cat_items.forEach(item => {
      item.discounts.forEach(discount => {
        if(discount.title == "subscription offer"){
          window.location.href = "/cart"
        }
      })
    })
    
    let product_id = parseInt($("form.installment [name='id']").val());

    var selling_plan;

    if(self.note_often === "2-4 days per week"){
      self.note_often = "Delivery every 3 months";
      
      if(currentProduct.selling_plan_groups){
        let selling_plan_groups = currentProduct.selling_plan_groups;
        selling_plan_groups.map(selling_plan => {
          let selling_id = selling_plan['selling_plans'][0].id;
          let name = $.trim(selling_plan.name);
          if(name == "3 month subscription"){
            window.selling_plan = selling_id;
          }
        })
      }
    }else if(self.note_often === "1 day a week or less"){
      self.note_often = "Delivery every 5 months";
      
      if(currentProduct.selling_plan_groups){
        let selling_plan_groups = currentProduct.selling_plan_groups;
        selling_plan_groups.map(selling_plan => {
          let selling_id = selling_plan['selling_plans'][0].id;
          let name = $.trim(selling_plan.name);
          if(name == "5 month subscription"){
            window.selling_plan = selling_id;
          }
        })
      }
    }else{
      self.note_often = "Delivery every 2 months";
      
      if(currentProduct.selling_plan_groups){
        let selling_plan_groups = currentProduct.selling_plan_groups;
        selling_plan_groups.map(selling_plan => {
          let selling_id = selling_plan['selling_plans'][0].id;
          let name = $.trim(selling_plan.name);
          if(name == "2 month subscription"){
            window.selling_plan = selling_id;
          }
        })
      }
    }
    // var selectedText = $('#sellingPlan8938943414609 option:selected').text();
    // console.log(selectedText);
    // return;

    var optionValue = "";

    $('#sellingPlan8938943414609 option').each(function() {
      var optionText = $(this).text();
      
      if (optionText === self.note_often) {
          optionValue = $(this).val();
          
          console.log("Matching value found: " + optionValue);
          
          return false;
      }
    });

    if(addOnProductId && isAddOnAdded){
      // items.push({
      //   id: addOnProductId,
      //   quantity: 1,
      // });
    }

    let img_src = "";

    if($('[name="upsell_product_id"]:checked').next().find("img").attr("src")){
      img_src = $('[name="upsell_product_id"]:checked').next().find("img").attr("src");
    }
    
    items.push({
      id: product_id,
      quantity: 1,
      selling_plan: window.selling_plan,
      properties: {
        img_src
      }
    });

    // alert(JSON.stringify(items))
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: items
      },
      dataType: 'json',
      success: function(response) {
        window.location.href = "/cart"
        
      },
      error: function(error) {
        console.error('Error adding product(s) to cart');
      }
    });
  }

  
}

new UpsellProduct(upsell_products);